import { domain } from 'modules/data';

export const otherWorkflows = [
    domain.IntegrationCode.XeroContact,
    domain.IntegrationCode.QBooksVendor,
    domain.IntegrationCode.QBooksJournalEntry,
    domain.IntegrationCode.XeroBillBatchPayment,
    domain.IntegrationCode.XeroAirwallexBatchPayment,
    domain.IntegrationCode.XeroAmaxPayBatchPayment,
    domain.IntegrationCode.XeroManualJournal,
];
